import { createSelector } from 'redux-orm';
import orm from '%paysera_seat_selection/js/seatSelection/redux/model';
import dbSelector from '%paysera_seat_selection/js/seatSelection/redux/component/orm/selectors/dbSelector';

export default createSelector(
    orm,
    dbSelector,
    ({ TicketType }) => TicketType.all()
        .toModelArray()
        .reduce(
            (accumulator, ticketType) => {
                if (
                    ticketType.seats.count() > 0
                    || ticketType.generalAdmissions.count() > 0
                ) {
                    accumulator.push(ticketType.hash);
                }
                return accumulator;
            },
            [],
        ),
);
